export default from './profile-placeholder.js';



// WEBPACK FOOTER //
// ./app/components/profile-placeholder/index.js